module.exports = __webpack_public_path__ + "static/img/logo-chemistry.44c7116.png";